import { PaymentMethod } from "@apac/components/checkout";
import {
  ApacHotelsComponent,
  useApacHotelsStyles,
} from "@apac/components/hotels";
import type { RewardsAndCreditsLineItem } from "@apac/hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import {
  BasePriceBreakdown,
  type BasePriceBreakdownProps,
} from "../BasePriceBreakdown";
import { DueAtPropertyTotal } from "../DueAtPropertyTotal";
import { PayAtProperty } from "../PayAtProperty";
import {
  TotalAmountLines,
  type TotalAmountLinesProps,
} from "../TotalAmountLines";
import defaultStyles from "./styles.module.scss";

interface PriceBreakdownSectionProps
  extends PlatformComponentProps,
    BasePriceBreakdownProps,
    TotalAmountLinesProps {
  rewardsAndCreditsLineItems?: RewardsAndCreditsLineItem[];
  cardDisplayName?: string;
  hidePaymentMethod?: boolean;
}

const COMPONENT_KEY = ApacHotelsComponent.PriceBreakdownReviewSection;

export const PriceBreakdownSection = ({
  className,
  children,
  rewardsAndCreditsLineItems = [],
  cardDisplayName,
  hidePaymentMethod = false,
  ...props
}: PriceBreakdownSectionProps) => {
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{t("priceBreakdown")}</div>
      <BasePriceBreakdown {...props} />
      <PayAtProperty fiatFormatOptions={props.fiatFormatOptions} />
      <TotalAmountLines {...props} className={cn("divider")} />
      {!hidePaymentMethod && (
        <PaymentMethod
          displayName={cardDisplayName}
          className={cn("payment-method")}
        />
      )}
      <DueAtPropertyTotal fiatFormatOptions={props.fiatFormatOptions} />

      {/* Often used for additional content such as extra terms & conditions */}
      {children != null && <div className={cn("disclaimer")}>{children}</div>}
    </div>
  );
};
